// extracted by mini-css-extract-plugin
export default {"wrapper":"up-z","response":"vp-z","error":"wp-z","disabled":"xp-z","buttons":"yp-z","feedbackQuestionSection":"zp-z","yesNoWrapper":"Ap-z"};